export const textToNumber = (value, format = "0,000.00") => {
  value = value.replaceAll(".", "");
  value = value.replaceAll(",", ".");

  return parseFloat(value);
};

export default textToNumber;
